export const URL_SEARCH =
  "https://927b868059194e5bbd45c5be8a8078b6.ent-search.us-east-1.aws.cloud.es.io/api/as/v1/engines";
